import MagstimTable from './MagstimTable';

class MagstimTableTreatmentTemplateBase extends MagstimTable {

    initForSelect = (data, heightPx) => {
        this.initImpl(this.configTableTreatmentTemplateSelect(data), heightPx);
    }

    initForEdit = (data, heightPx) => {
        this.initImpl(this.configTableTreatmentTemplateEdit(data), heightPx);
    }

    initImpl(configData, heightPx) {
        throw new Error('abstract method');
    }

    configTableTreatmentTemplateSelect(data) {
        return {
            singleselect: true,
            select: {
                checked: { icon: 'fas fa-dot-circle', color: '#00AEEF' },
                unchecked: { icon: 'fas fa-circle', color: '#C9DEFF' },
            },
            columns: this.columnsTableTreatmentTemplateSelect(),
            data: data
        };
    }

    configTableTreatmentTemplateEdit(data) {
        return {
            singleselect: false,
            //groupEditable: true,
            //groupEditableFormatter: this.formatEdit,
            columns: this.columnsTableTreatmentTemplateEdit(),
            data: data
        };
    }

    formatEdit(value, column, row) {
        
        //console.log('', value, column, row);
        const elemCheck = document.createElement('i');
        if ((undefined !== row.isSystemProtocol) && (null !== row.isSystemProtocol) && row.isSystemProtocol) {
            elemCheck.className = 'far fa-clone';
        }
        else {
            elemCheck.className = 'fas fa-edit';
        }
        elemCheck.style.color = '#C9DEFF';
        return elemCheck;
    }

    columnsTableTreatmentTemplateEdit() {
        var retVal = this.columnsTableTreatmentTemplateSelect();
        retVal.push({ title: '', property: 'mode', sortable: false, groupedColumn: true, formatter: this.formatEdit });
        return retVal;
    }

    formatSystemProtocol(value) {
        var retVal = ""
        if(value) {
            retVal = "FDA"
        }
        else {
            retVal = ""
        }
        return retVal;
    }

    columnsTableTreatmentTemplateSelect() {
        return [
            { title: 'Name', property: 'name', sortable: true },
            { title: '%rMT', property: 'pcRMT', sortable: false, formatter: this.formatPercent },
            { title: 'Hz (PPS)', property: 'pps', sortable: false },
            { title: 'Pulses', property: 'pulses', sortable: false },
            { title: 'Duration', property: 'duration', sortable: false, formatter: this.formatMinuteAndSeconds },
            { title: 'Mode', property: 'mode', sortable: false },
            { title: '', property: 'isSystemProtocol', optional: true, sortable: false, alwaysSortedDirection: -1, formatter: this.formatSystemProtocol }
            // { title: 'Wait time', property: 'waitTime', sortable: false, formatter: this.formatSeconds },
            // { title: 'Trains', property: 'trains', sortable: false }
        ];
    }

}

export default MagstimTableTreatmentTemplateBase;